<template>
  <div>
    <div class="header">
      <div class="header__item">
        <CustomInput
          label="Код"
          :value="this.filters.code"
          @change_input="val => onChange('code', val)"
        />
      </div>
      <div class="header__item" style="width: 150px;">
        <CustomSelect
          :options="this.bufferFilterOptions"
          label="Есть ли floor_param_id"
          optionValueKey="value"
          optionLabelKey="label"
          :value="this.filters.has_floor_param"
          @change="(value) => onChange('has_floor_param', value)"
        />
      </div>
      <q-btn
        type="submit"
        @click="this.getData"
        :loading="this.isFetching"
        :disable="this.deleting"
        size="sm"
        no-wrap
        color="primary"
      >
        <q-icon name="search" />
        Поиск
      </q-btn>
      <q-btn v-if="!!this.rowsData?.length" size="sm" no-wrap color="red">
        <q-icon name="delete" style="margin-right: 5px;" />
        Удалить все
        <PopupConfirm
          :loading="this.deleting"
          :approve="() => this.onDeleteSubmit(null, true)"
        />
      </q-btn>
    </div>
    <CustomTable
      title="Данные с буффера"
      :rowsData="this.data"
      :columns="this.bufferParamColumns"
      :loading="isFetching"
      :show-search="true"
      :custom-body="true"
    >
      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.index }}
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            <span>{{props.row.floor_param_type_name}}</span>
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <span>{{props.row.floor_buffer_id}}</span>
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <span>{{props.row.floor_param_id}}</span>
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.param_geom }}
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.rowversion }}
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.code }}
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <CustomIcon
              icon="trash"
              :approve-mode="true"
              :loading="!!this.deleteLoading[props.row.floor_buffer_id]"
              :approve="() => this.onDeleteSubmit(props.row.floor_buffer_id)"
            />
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import CustomIcon from "@/components/common/CustomIcon";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import {
  bufferFilterOptions,
  bufferParamColumns,
  deleteBufferParam,
  getBufferParamsList
} from "@/views/BufferParams/services";
import PopupConfirm from "@/components/common/PopupConfirm";

export default {
  name: "BufferParams",
  components: {CustomInput, CustomIcon, CustomTableCell, CustomTable, CustomSelect, PopupConfirm},
  data() {
    return {
      bufferFilterOptions,
      rowsData: [],
      bufferParamColumns,
      filters: {
        code: '',
        has_floor_param: null,
      },
      savedFilters: {},
      isFetching: false,
      deleteLoading: {},
      deleting: false,
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    data() {
      return this.rowsData?.map((item, i) => ({...item, index: i + 1}))
    }
  },
  methods: {
    async getData() {
      this.isFetching = true
      const res = await getBufferParamsList(this.filters)
      this.isFetching = false
      if (!res) return
      this.savedFilters = {...this.filters}
      this.rowsData = res
    },
    async onDeleteSubmit(floor_buffer_id, all = false) {
      if(this.deleting || this.deleteLoading[floor_buffer_id]) return
      let allIds = null
      if(all)
        allIds = this.rowsData.map(item => item.floor_buffer_id)

      if(all)
        this.deleting = true
      else
        this.deleteLoading = {...this.deleteLoading, [floor_buffer_id]: true}
      const res = await deleteBufferParam(floor_buffer_id, allIds, this.savedFilters)
      this.deleteLoading = {...this.deleteLoading, [floor_buffer_id]: false}
      if(all)
        this.deleting = false
      else
        this.deleteLoading = {...this.deleteLoading, [floor_buffer_id]: false}
      if (!res) return
      this.rowsData = res
      this.showSucceedSnackbar()
    },
    onChange(key, value) {
      this.filters[key] = value
      if(key === 'has_floor_param' && value ==='')
        this.filters[key] = null
    },
  },
  setup() {
    const {showSucceedSnackbar} = useCustomSnackbar();
    return {showSucceedSnackbar};
  },
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: flex-end;
  gap: 15px;
  flex-wrap: wrap;
  margin-bottom: 25px;
  &__item {
    width: 200px;
  }
  @media (max-width: 400px) {
    &__item {
      width: 100%;
    }
  }
}
</style>
